module.exports = __webpack_public_path__ + "img/NetworkTopology.3e287eb.svg";